module.exports = __webpack_public_path__ + "fonts/Pretendard-Medium.36381137.woff";